import { withDashboard } from '@apps/firsthomecoach/src/pages/dashboard/hocs/with-dashboard';
import { DefaultDashboard } from '@apps/firsthomecoach/src/pages/dashboard/component';

import { dashboardWidgets } from './widgets';

export const Dashboard = withDashboard(dashboardWidgets)(DefaultDashboard);
